import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { TranslocoService } from '@ngneat/transloco';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-worker-zoleo',
  templateUrl: './worker-zoleo.component.html',
  styleUrls: ['./worker-zoleo.component.scss']
})
export class WorkerZoleoComponent implements OnInit {

  @Input() worker:any;
  zoleoDevices: any[] = [];
  zoleoDeviceOptions: any[] = [];
  loadingDevices = false;
  deviceLoadError = '';
  selectedDeviceId: any = 'custom';

  formGroup = new FormGroup({
    zoleo: new FormControl('',[]),
    cell: new FormControl('',[])
  });

  submitted = false;
  username: any = "";
  //btn:any = document.getElementById("integration-btn");

  @Output() refreshWorker = new EventEmitter();

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log('worker',this.worker);

    this.setForm();
    this.setDeviceOptions();
    this.loadZoleoDevices();

    window.addEventListener('message',this.receiveMessage,false);

  }

  zoleoWindow(){
    //console.log('in zoleoWindow');
    //console.log('username',this.username);
    const btn:any = document.getElementById("integration-btn");

    //console.log(btn);

    if(btn){
      //console.log('yes btn');

      const popupWinWidth = 450;
      const popupWinHeight = 800;

      let left = (screen.width - popupWinWidth) /2;
      let top = (screen.height - popupWinHeight) /2;

      window.open("https://www.link.zoleo.com/?partnerID=e9443416-07d2-4887-9837-919cd422dc96&username="+this.username+"&partnerURL=https://my.okalone.net} ", "_blank", "'resizable=yes, width=" + popupWinWidth + ", height=" + popupWinHeight + ", top=" +top +"', left = "+left
      );

      this.receiveMessage;

    }

  }

  setForm(){
    this.formGroup.setValue({
      zoleo: this.worker.zoleo,
      cell: this.worker.cell || ''
    });
    //console.log(this.formGroup.value);
  }

  loadZoleoDevices(){
    this.loadingDevices = true;
    this.deviceLoadError = '';

    this.okService.get('devices', { sort: 'name', pagesize: 1000 }).subscribe({
      next: (data:any) => {
        const body = Array.isArray(data?.body) ? data.body : [];
        this.zoleoDevices = body.filter((device:any) => String(device?.type || '').toLowerCase() === 'zoleo');
        this.setDeviceOptions();
        this.syncSelectedDevice();
        this.loadingDevices = false;
      },
      error: () => {
        this.zoleoDevices = [];
        this.setDeviceOptions();
        this.loadingDevices = false;
        this.deviceLoadError = this.transloco.translate('Saved ZOLEO devices could not be loaded. You can still enter values manually.');
      }
    });
  }

  setDeviceOptions(){
    const customOption = {
      id: 'custom',
      display: this.transloco.translate('Custom Entry'),
      name: '',
      imei: '',
      number: ''
    };

    const options = this.zoleoDevices.map((device:any) => {
      const number = device.number ? ` - ${device.number}` : '';
      return {
        id: device.id,
        display: `${device.name} - ${device.imei}${number}`,
        name: device.name,
        imei: device.imei,
        number: device.number || ''
      };
    });

    this.zoleoDeviceOptions = [customOption, ...options];
  }

  syncSelectedDevice(){
    const currentImei = this.normalizeImei(this.formGroup.value.zoleo);
    if(!currentImei){
      this.selectedDeviceId = 'custom';
      return;
    }

    const selected = this.zoleoDevices.find((device:any) => this.normalizeImei(device.imei) === currentImei);
    this.selectedDeviceId = selected ? selected.id : 'custom';
  }

  onDeviceSelect(deviceId:any){
    this.selectedDeviceId = deviceId;
    if(deviceId === 'custom'){
      return;
    }

    const selected = this.zoleoDevices.find((device:any) => String(device.id) === String(deviceId));
    if(!selected){
      return;
    }

    this.formGroup.patchValue({
      zoleo: selected.imei || '',
      cell: selected.number || ''
    });
  }

  normalizeImei(value:any){
    return String(value || '').replace(/\D/g,'');
  }

  submitForm(){
    this.submitted = true;

    if(this.formGroup.valid){
      let values = this.formGroup.value;
      //console.log('values',values);
      this.okService.put("workers/"+this.worker.id,values)
      .subscribe((data) => {

        this.worker = data.body;
        this.setForm();
        this.refreshWorker.emit();

        this.okService.setAlert(this.transloco.translate("Your ZOLEO device has been updated"),"success");


      });

    }

    return false;
  }

  receiveMessage(e: any){

    if(e.origin === 'https://link.zoleo.com'){
      //console.log('receiveMessage',e);
    }

  }

}
